import { __assign, __awaiter, __generator, __read, __spread } from "tslib";
import React, { useState, memo, useEffect } from 'react';
import { Avatar, List, Select, Tag } from '@hose/eui';
import EkbHighLighter from '../EkbHighLighter';
import styles from './filter.module.less';
import { app } from '@ekuaibao/whispered';
import { debounce } from 'lodash';
import classnames from 'classnames';
import { filterStaff, getStaffShowByConfig, getStaffShowExternal } from '../utilFn';
import { DropdownRender, Loading, MaxTagPlaceholder } from './columnOthers';
import { getStaffs, setStaffs } from './FilterCache';
import { OutlinedTipsDone } from '@hose/eui-icons';
var pageCount = 200;
export var StaffFilter = memo(function (_a) {
    var value = _a.value, onChange = _a.onChange, onOk = _a.onOk, onReset = _a.onReset;
    var _b = __read(useState([]), 2), list = _b[0], setList = _b[1];
    var _c = __read(useState(value !== null && value !== void 0 ? value : []), 2), checkedKeys = _c[0], setCheckedKeys = _c[1];
    var _d = __read(useState(''), 2), searchStr = _d[0], setSearchStr = _d[1];
    var _e = __read(useState(false), 2), loading = _e[0], setLoading = _e[1];
    useEffect(function () {
        if (!!(value === null || value === void 0 ? void 0 : value.length)) {
            initList();
        }
    }, []);
    var initList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var staffs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getStaffs(value)];
                case 1:
                    staffs = _a.sent();
                    setList(staffs);
                    return [2];
            }
        });
    }); };
    var fetchData = function (searchKey) { return __awaiter(void 0, void 0, void 0, function () {
        var params, result, staffs;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!searchKey && !(value === null || value === void 0 ? void 0 : value.length)) {
                        return [2];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 4, 5]);
                    params = getParams(searchKey, checkedKeys);
                    setLoading(true);
                    return [4, app.invokeService('@contacts:search:staffs:list', params)];
                case 2:
                    result = _b.sent();
                    staffs = (_a = result === null || result === void 0 ? void 0 : result.items) !== null && _a !== void 0 ? _a : [];
                    return [4, setStaffs(staffs)];
                case 3:
                    _b.sent();
                    setList(staffs);
                    return [3, 5];
                case 4:
                    setLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var handleSearch = debounce(function (searchValue) {
        if (searchValue) {
            fetchData(searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim());
        }
        setSearchStr(searchValue);
    }, 500);
    var handleChange = function (value) {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
        setCheckedKeys(value);
    };
    var handleConfirm = function () {
        onOk === null || onOk === void 0 ? void 0 : onOk();
    };
    var handleReset = function () {
        setCheckedKeys([]);
        onReset === null || onReset === void 0 ? void 0 : onReset();
    };
    return (React.createElement("div", { className: styles['filter-content-wrapper'] },
        React.createElement(Select, { getPopupContainer: function (node) { return node.parentNode; }, placeholder: i18n.get('请输入要搜索的人员'), value: checkedKeys, dropdownRender: function (menu) { return React.createElement("div", { style: { display: 'none' } }, menu); }, mode: "multiple", maxTagPlaceholder: function (omittedValues) { return React.createElement(MaxTagPlaceholder, { omittedValues: omittedValues, titleKey: "title" }); }, onChange: handleChange, onSearch: handleSearch, filterOption: filterOptions, autoFocus: true, optionFilterProp: "children", style: { width: '100%' }, listHeight: 200, allowClear: true, showSearch: true, showArrow: true, virtual: true, open: true, maxTagCount: 2 }, list.map(function (item) {
            var title = getStaffShowByConfig(item);
            var status = getStatus(item);
            var showTitle = !!status ? title + "(" + status + ")" : title;
            return (React.createElement(Select.Option, { key: item.id, value: item.id, title: showTitle, data: item },
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center'
                    } },
                    React.createElement(StaffItem, { staff: item }))));
        })),
        React.createElement(DropdownRender, { className: styles['filter-dropdown-render'], originNode: React.createElement(StaffList, { loading: loading, list: list, value: checkedKeys, searchStr: searchStr, onChange: handleChange }), onConfirm: handleConfirm, onReset: handleReset })));
});
var StaffList = function (_a) {
    var _b = _a.value, value = _b === void 0 ? [] : _b, list = _a.list, loading = _a.loading, searchStr = _a.searchStr, onChange = _a.onChange;
    var handleItemChange = function (item) {
        var checkedData = __spread(value);
        if (checkedData.includes(item.id)) {
            checkedData = checkedData.filter(function (id) { return id !== item.id; });
        }
        else {
            checkedData.push(item.id);
        }
        onChange(checkedData, item);
    };
    return (React.createElement("div", { className: styles['list-wrapper'] }, loading ? (React.createElement(Loading, null)) : (React.createElement(List, { dataSource: list, renderItem: function (item) {
            var _a;
            var title = getStaffShowByConfig(item);
            var selected = value.includes(item === null || item === void 0 ? void 0 : item.id);
            return (React.createElement("div", { className: classnames(styles['list-item'], (_a = {}, _a[styles['list-item-checked']] = selected, _a)), onClick: function () { return handleItemChange(item); }, title: title },
                React.createElement("div", { className: "list-item-content" },
                    React.createElement(StaffItem, { staff: item, searchKey: searchStr })),
                selected && React.createElement(OutlinedTipsDone, { color: "var(--eui-primary-pri-500)" })));
        } }))));
};
export var StaffItem = function (_a) {
    var staff = _a.staff, _b = _a.searchKey, searchKey = _b === void 0 ? '' : _b;
    var title = getStaffShowByConfig(staff);
    var external = getStaffShowExternal(staff);
    var item = __assign(__assign({}, staff), { label: title });
    return (React.createElement(React.Fragment, null,
        React.createElement(Avatar, { shape: "circle", src: item === null || item === void 0 ? void 0 : item.avatar, size: "small", style: { marginRight: 4, width: 16, height: 16, lineHeight: '16px', marginBottom: 2 } }),
        !!searchKey ? (React.createElement(EkbHighLighter, { highlightClassName: styles['highlight'], searchWords: [searchKey], textToHighlight: staff.name })) : (staff.name),
        external,
        React.createElement(StatusTag, { item: staff })));
};
var filterOptions = function (input, option) {
    return filterStaff(input, option.data);
};
var getStatus = function (item) {
    var str = '';
    if (!item.active) {
        str = i18n.get('已离职');
    }
    else if (!item.authState && !item.external) {
        str = i18n.get('已停用');
    }
    return str;
};
export var StatusTag = function (_a) {
    var item = _a.item;
    var str = getStatus(item);
    if (!!str) {
        return (React.createElement(Tag, { style: { marginLeft: 4 }, size: "small" }, str));
    }
    return React.createElement(React.Fragment, null);
};
export var getParams = function (searchStr, checkedIds) {
    if (checkedIds === void 0) { checkedIds = []; }
    var query = {
        limit: {
            start: 0,
            count: pageCount
        },
        orderBy: [
            {
                value: 'active',
                order: 'DESC'
            },
            {
                value: 'authState',
                order: 'DESC'
            }
        ]
    };
    var filterBy = '';
    if (searchStr) {
        var lowerStr = searchStr.toLowerCase();
        filterBy = "lower(name).containsIgnoreCase(\"" + lowerStr + "\")||nickName.containsIgnoreCase(\"" + lowerStr + "\")||lower(nameSpell).containsIgnoreCase(\"" + lowerStr + "\")||lower(nameInitial).containsIgnoreCase(\"" + lowerStr + "\")||lower(enName).containsIgnoreCase(\"" + lowerStr + "\")";
    }
    if (checkedIds.length) {
        var ids = checkedIds.map(function (item) { return "\"" + item + "\""; });
        filterBy = (!!filterBy ? filterBy + "||" : '') + "id.in(" + ids.join(',') + ")";
    }
    if (!!filterBy) {
        query.filterBy = filterBy;
    }
    return {
        query: query,
        searchAll: true
    };
};
export default StaffFilter;
